// extracted by mini-css-extract-plugin
export default {"cardContainer":"RecoveryPasswordLayout_cardContainer__V9tR6","container":"RecoveryPasswordLayout_container__Pd0mG"};